var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found d-flex flex-column justify-content-center align-items-center"},[_c('h1',[_vm._v("Такой страницы не существует.")]),_c('router-link',{attrs:{"to":"/","tag":"a"}},[_vm._v(" Вернем вас на Главную")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }